import { render, staticRenderFns } from "./StudentAddress.vue?vue&type=template&id=33a9737a&scoped=true&"
import script from "./StudentAddress.vue?vue&type=script&lang=js&"
export * from "./StudentAddress.vue?vue&type=script&lang=js&"
import style0 from "./StudentAddress.vue?vue&type=style&index=0&id=33a9737a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a9737a",
  null
  
)

export default component.exports